import { Component, Inject } from '@angular/core';
import { ListBase } from "../shared/list.base";
import { CrewPermissionsService } from '../../core/crew-permissions.service';

@Component({
    selector: 'crew-cvcompetencegroups',
    template: require('../shared/list-view.html')
})
export class CVCompetenceGroups extends ListBase<Nema.Crew.Model.CVCompetenceGroup>  {
    constructor(
        @Inject("cvcompetencegroups") cvcompetencegroups: Nema.Crew.Model.CVCompetenceGroup[],
        crewPermissionsService: CrewPermissionsService) {

        super(cvcompetencegroups, crewPermissionsService);
    }

    public newEntityState = "app.settings.cvcompetencegroups.new";

    public editEntityState = "app.settings.cvcompetencegroups.detail";

    public entityName = "CV Competence Group";

    public entityNames = "CV Competence Groups";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/cvcompetencegroups/cvcompetencegroups.component.ts